import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { AuthService } from '../auth/auth.service';
import { isDefinedNotNullNotEmpty } from '../util';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  public constructor(
    private authService: AuthService,
    private logger: NGXLogger
  ) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public loggerPost(message: any, logItemDetails: any, level: number, scopes: string[]): void {
    this.logger.updateConfig({
      timestampFormat: 'medium',
      ...this.logger.getConfigSnapshot()
    });
    this.authService.getAccessToken(scopes)
      .subscribe((token: string): void => {
        if (isDefinedNotNullNotEmpty(token)) {
          this.logger.setCustomHttpHeaders(new HttpHeaders({ Authorization: `Bearer ${token}` }));
        } else {
          this.logger.setCustomHttpHeaders(new HttpHeaders({}));
        }
        switch (level) {
          case 0:
            this.logger.trace(message, logItemDetails);
            break;
          case 1:
            this.logger.debug(message, logItemDetails);
            break;
          case 2:
            this.logger.info(message, logItemDetails);
            break;
          case 3:
            this.logger.log(message, logItemDetails);
            break;
          case 4:
            this.logger.warn(message, logItemDetails);
            break;
          case 5:
            this.logger.error(message, logItemDetails);
            break;
          case 6:
            this.logger.fatal(message, logItemDetails);
            break;
          default:
            break;
        }
      });
  }

}
